import * as actions from './InstitutionAutoCompleteActions';

const initialState = {
  isLoading: false,
  institutions: [],
  errors: [],
  termQuery: '',
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actions.ERRORS_SET:
      return { ...state, errors: payload };
    case actions.IS_LOADING_SET:
      return { ...state, isLoading: payload };
    case actions.INSTITUTIONS_SET:
      return { ...state, errors: [], institutions: payload };
    case actions.SET_TERM_QUERY:
      return { ...state, termQuery: payload };
    default:
      return state;
  }
};
